"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageProductsFavourites = void 0;
const gs = require("@ivanlog/gs");
const tmpls_1 = require("./tmpls");
const App_1 = require("../App");
const StatePaged_1 = require("../states/abstracts/StatePaged");
const CmpProductTile_1 = require("./CmpProductTile");
const ClassesTags_1 = require("../ClassesTags");
const FavoriteController_1 = require("../../appProfiMall/controllers/FavoriteController");
class PageProductsFavourites extends tmpls_1.PageProductsFavouritesBase {
    constructor() {
        super();
        this._productIds = [];
        this._skip = 0;
        this.ctrls.cmpFilterLine.hide();
        this.ctrls.cmpPagination.ctrls.btnNext.onclick = () => this._loadNextAsync();
    }
    setIsTab() {
        return __awaiter(this, void 0, void 0, function* () {
            this.addClass('is_profile_tab');
            this.ctrls.lHeader.text = '';
        });
    }
    loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._skip = 0;
            this.ctrls.blockEmpty.hide();
            this.ctrls.blockFavorite.hide();
            this.ctrls.cmpPagination.hide();
            this._addListPlaceholders();
            this._productIds = App_1.App.Inst.getInst(FavoriteController_1.FavoriteController).getFavorites();
            if (this._productIds.length == 0) {
                this.ctrls.blockEmpty.show();
                return;
            }
            else
                this.ctrls.blockFavorite.show();
            this.ctrls.cmpFilterLine.ctrls.lFoundedCount.text = 'Найдено ' + this._productIds.length;
            this._loadNextAsync(true);
        });
    }
    _loadNextAsync(withClearList = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let takeIds = this._productIds.slice(this._skip, this._skip + StatePaged_1.StatePaged.TakeProductsCount);
            this.ctrls.cmpPagination.disable();
            let products = yield App_1.App.Inst.cache.getProductsAsync(takeIds);
            this.ctrls.cmpPagination.enable();
            if (withClearList)
                this.ctrls.listProducts.html = '';
            if (!products) {
                return;
            }
            for (const prod of products) {
                let item = new CmpProductTile_1.CmpProductTile();
                item.fill(prod);
                this.ctrls.listProducts.append(item);
            }
            gs.StateGS.CatchLinks();
            this._skip += StatePaged_1.StatePaged.TakeProductsCount;
            this.ctrls.cmpPagination.show();
            if (this._skip >= this._productIds.length)
                this.ctrls.cmpPagination.hide();
        });
    }
    _addListPlaceholders() {
        for (let i = 0; i < StatePaged_1.StatePaged.TakeProductsCount; i++) {
            let item = new CmpProductTile_1.CmpProductTile();
            item.addClass(ClassesTags_1.ClassesTags.Loading);
            this.ctrls.listProducts.append(item);
        }
    }
}
exports.PageProductsFavourites = PageProductsFavourites;
//# sourceMappingURL=PageProductsFavourites.js.map